export enum CustomerGeneralOption {
    CustomerNotes = 1,
    Edit = 2
}